<template>
  <div class="flex min-h-screen bg-gray-100">
    <!-- Sidebar: show only if logged in -->
    <SideBar v-if="showSidebar" />

    <!-- Main content -->
    <main class="flex-1 p-6 overflow-auto h-screen">
      <router-view />
      <ChatWidget v-if="showChat" />

      <!-- Footer with app version -->
      <footer class="mt-6 text-center text-sm text-gray-500">
        Version {{ version }}
      </footer>
    </main>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useAuth } from "@/stores/auth";
import ChatWidget from "./ChatComponents/ChatWidget.vue";
import SideBar from "./SideBar.vue";

// Simple event emitter for Vue
class SimpleEventEmitter {
  constructor() {
    this.events = {};
  }
  
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }
  
  off(event, listener) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(l => l !== listener);
  }
  
  emit(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach(listener => listener(data));
  }
}

export default defineComponent({
  components: { SideBar, ChatWidget },
  setup() {
    const route = useRoute();
    const auth = useAuth();

    const isLoggedIn = computed(() => !!auth.token.value);
    const showSidebar = computed(
      () => isLoggedIn.value && !["/login", "/register"].includes(route.path)
    );
    const showChat = computed(() => {
      const chatRoles = route.meta.chatRoles;
      const userType = auth.user.value?.user_type;
      const normalizedUserType =
        typeof userType === "string" ? userType.toLowerCase() : userType?.name?.toLowerCase();

      return isLoggedIn.value && chatRoles?.includes(normalizedUserType);
    });

    // import package.json default and expose version property
    const pkg = require("../package.json");
    
    // Create event bus for chat communication
    const chatEventBus = new SimpleEventEmitter();

    return { isLoggedIn, showSidebar, showChat, version: pkg.version, chatEventBus };
  },
  provide() {
    return {
      chatEventBus: this.chatEventBus,
    };
  },
});
</script>
